import getApiUrl from "../helpers/getApiUrl";
import getEnvironment from "../helpers/getEnvironment";

const untrackVehicle = async (
  vrm: string | string[],
  saleCode: string,
  inventoryID: string | null,
  isToUseAuthZero: boolean = false,
  accessToken?: string
) => {
  const isLocalhost = !["preview", "production"].includes(getEnvironment());
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };

  if (isToUseAuthZero && accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  } else if (!isToUseAuthZero && isLocalhost && process.env.token) {
    headers.Authorization = `Bearer ${process.env.token}`;
  }

  const untrackURL = getApiUrl(
    `${process.env.apiFunctionUrl}/api/buyer/tracked/${vrm}/${saleCode}?inventoryID=${inventoryID}`,
    isToUseAuthZero
  );

  const res = await fetch(untrackURL, {
    method: "DELETE",
    headers,
  });

  if (res.status === 200) {
    return res.json().catch(() => res);
  }

  return res;
};

export default untrackVehicle;
